export default "__VITE_ASSET__DnkFfznH__"